import { render } from "./BulkStoreElementView.vue?vue&type=template&id=974b0202&ts=true"
import script from "./BulkStoreElementView.vue?vue&type=script&lang=ts"
export * from "./BulkStoreElementView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__